import React from 'react';
import EditSubscriptionModal from '@app/organisms/EditSubscriptionModal';

const OffersPage = () => {
    return <EditSubscriptionModal isOpened={true} />;
};

export default OffersPage;
